var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('router-view',{attrs:{"organisation":_vm.organisation},on:{"updatedInformation":_vm.updatedInformation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }